import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46f61fe2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Descriptions = _resolveComponent("Descriptions")!
  const _component_Nodata = _resolveComponent("Nodata")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createBlock(_component_a_spin, {
    tip: "加载中...",
    spinning: _ctx.spinning
  }, {
    default: _withCtx(() => [
      (_ctx.list.length)
        ? (_openBlock(), _createElementBlock("section", {
            key: 0,
            class: _normalizeClass(_ctx.theme)
          }, [
            _createVNode(_component_Descriptions, {
              data: _ctx.list,
              size: "small",
              bordered: ""
            }, null, 8, ["data"])
          ], 2))
        : (_openBlock(), _createElementBlock("section", _hoisted_1, [
            _createVNode(_component_Nodata, {
              nodatadesc: _ctx.itemdata.title
            }, null, 8, ["nodatadesc"])
          ]))
    ]),
    _: 1
  }, 8, ["spinning"]))
}